import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { startAnalytics, trackPageview } from "@/lib/analytics";

/**
 * Sends a first-party pageview on every route change.
 * Must be called inside a component wrapped by BrowserRouter.
 */
export function useAnalyticsTracking() {
  const location = useLocation();

  useEffect(() => {
    startAnalytics();
  }, []);

  useEffect(() => {
    trackPageview(location.pathname, location.search);
  }, [location.pathname, location.search]);
}
